import type { LoginResponse, Session } from "../types";

// Local session persistence. The Vaas.Api also sets an HttpOnly `vaas_token`
// cookie on login, but that cookie is not readable from JS, so the portal keeps
// its own copy of the bearer token for Authorization headers.
const STORAGE_KEY = "survantic_support_session";

export function getSession(): Session | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as Session) : null;
  } catch {
    return null;
  }
}

export function setSession(login: LoginResponse): Session {
  const session: Session = {
    token: login.token,
    email: login.email,
    username: login.username,
    role: login.role,
    allowedSiteIds: login.allowedSiteIds,
    mustChangePassword: Boolean(login.mustChangePassword),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  return session;
}

export function clearSession(): void {
  localStorage.removeItem(STORAGE_KEY);
}

export function getToken(): string | null {
  return getSession()?.token ?? null;
}
